import { ActionTypes } from '../constants/index';

export const getUserInfo = (payload: any) => ({
  type: ActionTypes.USERINFO_REQUEST,
  payload: {
    id: payload,
  },
});
